import { webLogger } from '@muse-web/logger'
import { ChunkLoadFailure } from '@muse-web/router'
import { sendErrorShow } from '@core/analytics'
import { Logger } from '@core/logger'

export const reportPageError = (error: unknown, details?: string) => {
    sendErrorShow('page_error', error, details)
}

const isLogExtras = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null

const getErrorDetails = (extras: Record<string, unknown> | undefined) =>
    typeof extras?.details === 'string' && extras.details !== '' ? extras.details : undefined

export const routerLogger = {
    ...webLogger,
    error: (value: unknown, extras?: unknown) => {
        const error = typeof value === 'string' || value instanceof Error ? value : String(value)
        const details = isLogExtras(extras) ? extras : undefined

        if (typeof value !== 'string') {
            reportPageError(
                value instanceof ChunkLoadFailure ? (value.cause ?? value) : value,
                getErrorDetails(details),
            )
        }

        Logger.error(error, details)
    },
}
